function getIbanValidationEndpoint() {
  return '/iban/validate';
}

function getNotificationsEndpoint() {
  return '/notifications-center';
}
function updateNotificationStatus() {
  var notificationId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':notificationId';
  return "/notifications-center/".concat(notificationId, "/status");
}

var prefix = '/storage';
function getStorageFileUploadEndpoint() {
  return "".concat(prefix, "/upload");
}
function getStorageDirectFileUploadEndpoint() {
  return "".concat(prefix, "/direct-upload");
}

function getAddressValidationEndpoint() {
  return '/address/validate';
}
function getAddressValidationAutocompleteEndpoint() {
  return '/address/autocomplete';
}

function getVehicleImageServiceEndpoint(encryptedVin) {
  return "/vehicle-image-service/vehicle/".concat(encryptedVin);
}

function getVehicleServiceEndpoint(encryptedVin, language) {
  return "/vehicle-service/vehicle/".concat(encryptedVin, "/").concat(language);
}

function sendCustomerIndexEndpoint() {
  return '/customer-index/send';
}
function searchCustomerIndexEndpoint() {
  return '/customer-index/search';
}
function deleteCustomerIndexItemEndpoint(identifierType) {
  return "/customer-index/delete-item/".concat(identifierType);
}

function getPhoneValidationEndpoint() {
  return '/phone-number/validate';
}

var VehicleImageView;

(function (VehicleImageView) {
  VehicleImageView["EXTERIOR_FRONT_RIGHT"] = "EXTERIOR_FRONT_RIGHT";
  VehicleImageView["EXTERIOR_SIDE_RIGHT"] = "EXTERIOR_SIDE_RIGHT";
  VehicleImageView["EXTERIOR_BACK_RIGHT"] = "EXTERIOR_BACK_RIGHT";
  VehicleImageView["EXTERIOR_BACK_LEFT"] = "EXTERIOR_BACK_LEFT";
  VehicleImageView["EXTERIOR_SIDE_LEFT"] = "EXTERIOR_SIDE_LEFT";
  VehicleImageView["EXTERIOR_FRONT_LEFT"] = "EXTERIOR_FRONT_LEFT";
  VehicleImageView["EXTERIOR_FRONT_CENTER"] = "EXTERIOR_FRONT_CENTER";
  VehicleImageView["EXTERIOR_BACK_CENTER"] = "EXTERIOR_BACK_CENTER";
  VehicleImageView["INTERIOR_CENTER"] = "INTERIOR_CENTER";
  VehicleImageView["INTERIOR_SIDE"] = "INTERIOR_SIDE";
  VehicleImageView["EXTERIOR_WHEEL"] = "EXTERIOR_WHEEL";
  VehicleImageView["UNKNOWN"] = "UNKNOWN";
})(VehicleImageView || (VehicleImageView = {}));

var CustomerIndexIdentifierType;

(function (CustomerIndexIdentifierType) {
  CustomerIndexIdentifierType["AUDIID"] = "AUDIID";
  CustomerIndexIdentifierType["FSID"] = "FSID";
  CustomerIndexIdentifierType["LIVECONTRACTID"] = "LIVECONTRACTID";
  CustomerIndexIdentifierType["SEATID"] = "SEATID";
  CustomerIndexIdentifierType["SKODAID"] = "SKODAID";
  CustomerIndexIdentifierType["VERIMIID"] = "VERIMIID";
  CustomerIndexIdentifierType["VWID"] = "VWID";
  CustomerIndexIdentifierType["CARPRO_USER"] = "CARPRO_USER";
  CustomerIndexIdentifierType["PAYBYPHONEID"] = "PAYBYPHONEID";
  CustomerIndexIdentifierType["AUTOABO_TRANSACTION"] = "AUTOABO_TRANSACTION";
  CustomerIndexIdentifierType["AUTOABO_PAYMENTSERIES"] = "AUTOABO_PAYMENTSERIES";
  CustomerIndexIdentifierType["CARPRO_RESERVATION"] = "CARPRO_RESERVATION";
  CustomerIndexIdentifierType["AOD_RENT_RESERVATION"] = "AOD_RENT_RESERVATION";
  CustomerIndexIdentifierType["AUTOABO_RESERVATION"] = "AUTOABO_RESERVATION";
  CustomerIndexIdentifierType["SALES_CONTRACT"] = "4SALES_CONTRACT";
  CustomerIndexIdentifierType["AUTOABO_MERCHANTKEY"] = "AUTOABO_MERCHANTKEY";
  CustomerIndexIdentifierType["EMAIL"] = "EMAIL";
  CustomerIndexIdentifierType["EMAIL_AUDIID"] = "EMAIL_AUDIID";
  CustomerIndexIdentifierType["EMAIL_FSID"] = "EMAIL_FSID";
  CustomerIndexIdentifierType["EMAIL_VWID"] = "EMAIL_VWID";
  CustomerIndexIdentifierType["EMAIL_SKODAID"] = "EMAIL_SKODAID";
  CustomerIndexIdentifierType["EMAIL_SEATID"] = "EMAIL_SEATID";
  CustomerIndexIdentifierType["EMAIL_VERIMIID"] = "EMAIL_VERIMIID";
  CustomerIndexIdentifierType["RAC_RESERVATION"] = "RAC_RESERVATION";
  CustomerIndexIdentifierType["MARKET_USER_ES"] = "MARKET_USER_ES";
  CustomerIndexIdentifierType["MARKET_USER_NL"] = "MARKET_USER_NL";
  CustomerIndexIdentifierType["MARKET_USER_NLD"] = "MARKET_USER_NLD";
  CustomerIndexIdentifierType["MARKET_USER_JPN"] = "MARKET_USER_JPN";
  CustomerIndexIdentifierType["MARKET_USER_FR"] = "MARKET_USER_FR";
  CustomerIndexIdentifierType["MARKET_USER_IT"] = "MARKET_USER_IT";
  CustomerIndexIdentifierType["MARKET_USER_PT"] = "MARKET_USER_PT";
  CustomerIndexIdentifierType["MARKET_USER_UK"] = "MARKET_USER_UK";
  CustomerIndexIdentifierType["MARKET_USER_IE"] = "MARKET_USER_IE";
  CustomerIndexIdentifierType["MARKET_USER_SK"] = "MARKET_USER_SK";
  CustomerIndexIdentifierType["MARKET_USER_CZ"] = "MARKET_USER_CZ";
  CustomerIndexIdentifierType["MARKET_USER_MX"] = "MARKET_USER_MX";
  CustomerIndexIdentifierType["MARKET_USER_GR"] = "MARKET_USER_GR";
  CustomerIndexIdentifierType["MSP_MILES_USER"] = "MSP_MILES_USER";
  CustomerIndexIdentifierType["PSP_LOGPAY_USER"] = "PSP_LOGPAY_USER";
  CustomerIndexIdentifierType["DDM_PROSPECT_TRANSACTION"] = "DDM_PROSPECT_TRANSACTION";
})(CustomerIndexIdentifierType || (CustomerIndexIdentifierType = {}));

var TrustedShopsIntegrationCustomType;

(function (TrustedShopsIntegrationCustomType) {
  TrustedShopsIntegrationCustomType["CUSTOMERPORTAL"] = "customerportal";
  TrustedShopsIntegrationCustomType["CUSTOMERPORTAL_FAQ"] = "customerportal_faq";
  TrustedShopsIntegrationCustomType["CUSTOMERPORTAL_PROFILE"] = "customerportal_profile";
  TrustedShopsIntegrationCustomType["CUSTOMERPORTAL_REQUEST"] = "customerportal_request";
  TrustedShopsIntegrationCustomType["CUSTOMERPORTAL_FINANCING"] = "customerportal_financing";
  TrustedShopsIntegrationCustomType["CUSTOMERPORTAL_RENTING"] = "customerportal_renting";
})(TrustedShopsIntegrationCustomType || (TrustedShopsIntegrationCustomType = {}));

var AddressValidationResultType;

(function (AddressValidationResultType) {
  AddressValidationResultType["LOCALITY"] = "locality";
  AddressValidationResultType["STREET"] = "street";
  AddressValidationResultType["HOUSE_NUMBER"] = "houseNumber";
  AddressValidationResultType["AREA"] = "administrativeArea";
  AddressValidationResultType["BLOCK"] = "addressBlock";
  AddressValidationResultType["INTERSECTION"] = "intersection";
  AddressValidationResultType["POSTAL_CODE"] = "postalCodePoint";
})(AddressValidationResultType || (AddressValidationResultType = {}));

export { AddressValidationResultType, CustomerIndexIdentifierType, TrustedShopsIntegrationCustomType, VehicleImageView, deleteCustomerIndexItemEndpoint, getAddressValidationAutocompleteEndpoint, getAddressValidationEndpoint, getIbanValidationEndpoint, getNotificationsEndpoint, getPhoneValidationEndpoint, getStorageDirectFileUploadEndpoint, getStorageFileUploadEndpoint, getVehicleImageServiceEndpoint, getVehicleServiceEndpoint, searchCustomerIndexEndpoint, sendCustomerIndexEndpoint, updateNotificationStatus };
//# sourceMappingURL=index.es.js.map
